<template>
  <v-container class="account-container">
    <template v-if="activeTab === 'account'">
      <div class="mb-8 f-lg">{{ $t("welcome") || "HELLO" }} {{ fullName }}</div>

      <v-card
        v-if="activeTab === 'account'"
        class="bg-white bg-primary-light p-3"
        flat
      >
        <div class="content-between mb-8">
          <span class="f-md">{{ $t("profile_general") }}</span>
          <v-spacer></v-spacer>
          <div
            class="p-0"
            v-if="!isEditing"
            variant="text"
            @click="editProfile"
          >
            {{ $t("edit") }}
          </div>

          <div
            class="p-0"
            v-if="isEditing"
            variant="text"
            @click="isEditing = false"
          >
            {{ $t("close_edit") }}
          </div>
          <!-- <c-img v-if="!isEditing" class="ml-3" /> -->
          <font-awesome-icon
            v-if="!isEditing"
            icon="chevron-right"
            size="xs"
            class="ml-2"
          ></font-awesome-icon>
          <font-awesome-icon
            v-if="isEditing"
            icon="times"
            size="xs"
            class="ml-2"
            @click="isEditing = false"
          ></font-awesome-icon>
        </div>

        <v-list v-if="!isEditing" class="profile">
          <template v-for="(value, key) in userInfo" :key="key">
            <v-list-item v-if="userInfo[key].display" class="px-0">
              <v-list-item-title class="mb-1"
                >{{ userInfo[key].display }}
                <span v-if="$isMinimalMinibar">*</span>
              </v-list-item-title>
              <v-list-item-subtitle class="color-black">{{
                userInfo[key].value || "-"
              }}</v-list-item-subtitle>
            </v-list-item>
          </template>
        </v-list>

        <v-form v-else>
          <EditProfilePanel
            @onFinish="onFinish"
            @closeEditPanel="closeEditPanel"
            componentKey
          />
        </v-form>
      </v-card>
      <v-card
        class="bg-white bg-primary-light p-3 mt-3"
        flat
        v-if="activeTab === 'account'"
      >
        <v-list-item>
          <div class="d-flex align-items-center" @click="$emit('logout')">
            <div>
              <c-img
                :src="require('@/assets/images/clean/logout.png')"
                @error="handleImageSrc"
                style="width: 15px; height: 15px"
                alt="user icon tabs"
                class="mr-2 mb-1"
              />
            </div>
            {{ $t("logout") }}
          </div>
        </v-list-item>
      </v-card>
    </template>
    <!-- <ConpouPage v-else /> -->
    <!-- </v-slide-x-reverse-transition> -->

    <!-- <v-slide-x-reverse-transition mode="out-in"> -->
    <template v-if="activeTab === 'purchase'">
      <component :is="layoutComponent" />
    </template>

    <!-- </v-slide-x-reverse-transition> -->
  </v-container>

  <v-footer class="footer-tab" fill>
    <div class="footer-line"></div>
    <v-tabs grow center-active fixed-tabs v-model="activeTab">
      <v-tab
        value="purchase"
        :class="{ 'active-tab': activeTab == 'purchase' }"
        class="profile-tabs"
      >
        <div
          class="flex-column d-flex justify-center align-center"
          style="row-gap: 0.35rem"
        >
          <c-img
            :src="require('@/assets/images/clean/transaction.png')"
            @error="handleImageSrc"
            class="icon-tabs"
            alt="shopping icon tabs"
          />

          <div class="f-semi-sm">{{ $t("minimal_transaction_tab_title") }}</div>
        </div>
      </v-tab>
      <v-tab
        value="account"
        :class="{ 'active-tab': activeTab == 'account' }"
        class="profile-tabs"
      >
        <div
          class="flex-column d-flex justify-center align-center"
          style="row-gap: 0.35rem"
        >
          <!-- <font-awesome-icon icon="user"></font-awesome-icon> -->

          <c-img
            :src="require('@/assets/images/clean/user.png')"
            @error="handleImageSrc"
            class="icon-tabs"
            alt="user icon tabs"
          />
          <div class="f-semi-sm">{{ $t("minimal_profile_tab_title") }}</div>
        </div>
      </v-tab>
    </v-tabs>
  </v-footer>

  <ModalQrCode
    ref="qrCode"
    :value="qrType == 'Telephone' ? profile.telephone : profile.member_id"
  />
  <ModalLoading ref="modalLoading" />
</template>

<script>
import { mapState } from "vuex";
import { defineAsyncComponent, h } from "vue";
import ModalLoading from "@/components/other/ModalLoading.vue";
// import EditProfilePanel from "@/views/page/editprofile/editProfilePanel";
// import ModalQrCode from "@/components/profile/modal/ModalQrCode";
// import ConpouPage from "./page/CouponPage.vue";
import tabUserIcon from "@/assets/images/user-tabs.png";
export default {
  components: {
    // ModalQrCode,

    ModalLoading,
    // EditProfilePanel,
    // ConpouPage
    EditProfilePanel: defineAsyncComponent({
      loader: () => import("@/views/page/editprofile/editProfilePanel"),
      delay: 200,
      timeout: 10000,
      loadingComponent: {
        render() {
          return h("div", { class: "pa-4" }, "กำลังโหลด EditProfile...");
        }
      },
      errorComponent: {
        render() {
          return h(
            "div",
            { class: "pa-4 red--text" },
            "โหลด EditProfile ไม่สำเร็จ"
          );
        }
      }
    }),

    ModalQrCode: defineAsyncComponent(() =>
      import("@/components/profile/modal/ModalQrCode")
    ),

    ConpouPage: defineAsyncComponent(() => import("./page/CouponPage.vue")),
    Spinner: defineAsyncComponent(() =>
      import("@/components/other/Spinner.vue")
    )
  },

  data() {
    return {
      activeTab: "account",
      isEditing: false,
      user: {
        ...this.profile
        // full_name:
      },
      qrType: this.$store.state.theme.qr_code,
      profileEdit: {},
      menu: false,
      date: null,
      userInfo: {},
      mainProps: {
        center: true,
        fluidGrow: false,
        blank: true,
        blankColor: "#bbb",
        width: 300,
        height: 300,
        class: ""
      },
      tabUserIcon,
      displayPage: 1
    };
  },
  watch: {
    activeTab(value) {
      this.displayPage = 1;
      this.$router.replace("/profile#" + value);
      this.isEditing = false;
    }
  },
  async created() {
    this.setProfile();
  },
  computed: {
    ...mapState({
      profile: state => state.shortProfile
    }),
    layoutComponent() {
      const loader = this.$isCleanLayout
        ? () => import("./page/cleanLayout/PurchaseTab.vue")
        : () => import("./page/PurchaseTab.vue");

      return defineAsyncComponent({
        loader,
        delay: 200,
        timeout: 10000,
        loadingComponent: {
          render() {
            return h("div", { class: "pa-4" }, "Loading..");
          }
        },
        errorComponent: {
          render() {
            return h(
              "div",
              { class: "pa-4", style: "color:red" },
              "โหลดไม่สำเร็จ"
            );
          }
        }
      });
    },

    fullName() {
      const first_name = this.profile.first_name_th
        ? this.profile.first_name_th.toUpperCase()
        : this.profile.first_name_th;
      const middle_name = this.profile.middle_name_th
        ? this.profile.middle_name_th.toUpperCase()
        : "";
      const last_name = this.profile.last_name_th
        ? this.profile.last_name_th.toUpperCase()
        : "";
      return first_name + " " + middle_name + " " + last_name;
    },
    birthday() {
      return this.$moment(this.profileEdit.birthday)
        .subtract(543, "year")
        .format("DD/MM/YYYY");
    }
  },
  methods: {
    async setProfile() {
      const data = await this.$store.dispatch(
        "getProfileFields",
        this.profile.login_type
      );
      const findDisplayName = id => {
        let find = data.detail.result.fields.find(
          el => el.field_profile_type_id == id
        ).field_language;
        if (find.length > 0) return find[0].name;
        return "";
      };
      const findChoiceName = id => {
        let find = data.detail.result.fields.find(
          el => el.field_profile_type_id == id
        ).field_choices;
        if (find.length > 0) return find[0].display_name;
        return "";
      };

      const province = await this.$store.dispatch("getProvince");

      let selectProvince = province.find(
        el => el.name == this.profile.province
      );

      this.userInfo = {
        first_name: {
          display: findDisplayName(3),
          value: this.profile.first_name_th
            ? this.profile.first_name_th.toUpperCase()
            : this.profile.first_name_th
        },
        middle_name: {
          display: findDisplayName(31),
          value: this.profile.middle_name
            ? this.profile.middle_name.toUpperCase()
            : this.profile.middle_name
        },
        last_name: {
          display: findDisplayName(5),
          value: this.profile.last_name_th
            ? this.profile.last_name_th.toUpperCase()
            : this.profile.last_name_th
        },

        email: {
          display: findDisplayName(11),
          value: this.profile.email
        },
        birthday: {
          display: findDisplayName(9),
          value: this.profile.birthday
            ? this.$moment(this.profile.birthday).format("DD/MM/YYYY")
            : ""
        },
        gender: { display: findDisplayName(21), value: this.profile.gender },
        city: {
          display: findDisplayName(18),
          value: selectProvince?.display_name || this.profile.province
        },

        country: { display: findDisplayName(24), value: findChoiceName(24) }
      };
    },
    formatDate(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`; // เปลี่ยนเป็น DD/MM/YYYY
    },
    editProfile() {
      this.profileEdit = {
        ...this.profile,
        birthday: new Date(this.$moment(this.profile.birthday).format()),
        full_name: this.profile.first_name_th + " " + this.profile.last_name_th
      };
      this.isEditing = true;
    },

    async onFinish() {
      await this.$store.dispatch("refreshUserProfile");
      await this.setProfile();
      this.isEditing = false;
    },
    closeEditPanel() {
      this.isEditing = false;
    },
    classCard() {
      if (this.$isShowTab)
        return "border-sm rounded-4 p-3 bg-profile-card bg-primary-light";
      if (this.$isMinimalMinibar)
        return "p-3 bg-minibar-card  bg-primary-light";
      return "";
    }
  }
};
</script>

<style scoped lang="scss">
.account-container {
  margin: auto;
  height: calc(100svh - var(--padding-footer));
  overflow-y: auto; // padding-top: 0;
}

.welcome-text {
  font-size: var(--text-xl);
}

.member-id {
  font-size: var(--text-lg);
}

.v-list-item {
  padding: 0;
  padding-inline: 0 !important;
}

:deep(.v-tab.v-tab--selected) {
  // font-weight: bold !important;
  opacity: 1;
}

:not(.tab-minibar) v-tab.v-tab.v-btn {
  // min-width: 150px;
  padding-top: 10px;
}
.logout {
  position: absolute;
  top: 0;
  right: 0;
  height: max-content !important;
  /* font-size: 12px; */
}

::v-deep.logout .v-btn__content {
  font-size: 12px;
}

.footer-tab {
  position: fixed;
  bottom: 0;
  background-color: var(--theme-background-color);
  padding: 5px 15px 40px 15px; // border-top: 1px solid #f7f7f7;
  ::v-deep button {
    border-top: 1px solid;
    border-color: transparent;
  }
  .active-tab {
    border-color: black;
  }
  .active-tab-minibar {
  }
}

.logo-profile {
  width: 100%;
  max-width: 80%;
}

.footer-line {
  height: 1px;
  left: 0;
  width: 100vw;
  position: absolute;
  top: 0;
  border: thin solid #f7f7f7;
}
.icon-tabs {
  width: 20px;
  height: 20px;
}
.pencil-icon {
  width: 12.5px;
  height: 12.5px;
}
.tab-minibar {
  background: var(--bar-color);
  padding: 10px 16px;
  width: 100%;
  border-radius: 4px;
}
.minibar-tab-active {
  background-color: white;
  padding: 0.5rem;
  border-radius: 50%;
}
::v-deep .v-label.v-field-label {
  margin-inline-start: unset !important;
}
::v-deep .v-text-field input,
::v-deep .v-field__input {
  padding-inline: unset !important;
}
</style>
